// extracted by mini-css-extract-plugin
module.exports = {"rooms-grid":"RoomsGrid_rooms-grid__Xix9U","rooms-grid-item":"RoomsGrid_rooms-grid-item__ik1pT"};